import MssIcon from "../../common/MssIcon";

const SensorBatteryIcon = ({ percentage }: { percentage: number }) => {
  switch (true) {
    case percentage > 76:
      return <MssIcon name="battery-1" />;
    case percentage > 51 && percentage <= 76:
      return <MssIcon name="battery-2" />;
    case percentage > 25 && percentage <= 51:
      return <MssIcon name="battery-3" />;
    case percentage > 0 && percentage <= 25:
      return <MssIcon name="battery-4" />;
    default:
      return <MssIcon name="battery-5" />;
  }
};

export default SensorBatteryIcon;
